import React, { useEffect, useState } from 'react';
import Map from '../Map';
import MapLoading from '../MapLoading';
import { makeMSRequest } from '../helpers';

const MediaExplorerDataPanel = ({ publication, loading, setLoading }) => {
  const [pubsi, setPubsi] = useState(null);

  useEffect(() => {
    if (!publication) {
      setPubsi(null);
      return;
    }

    setLoading(true);

    const data = { publication: publication.toLowerCase() };

    makeMSRequest(`/wp-json/ms/v1/pubsi`, 'POST', data)
      .then((response) => {
        setPubsi(response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [publication]);

  if (loading) {
    return <MapLoading />;
  }

  return (
    <div className="media-explorer--data-panel">
      {pubsi && (
        <Map
          pubsi={pubsi.data}
          publication={pubsi.publication}
          description={pubsi.publication_description}
          overallReach={pubsi.overall_reach}
          timeseries={pubsi.timeseries}
        />
      )}
    </div>
  );
};

export default MediaExplorerDataPanel;
